<template>
  <div class="v-login-index"
    :class="{ 'role': isRoleSelect, 'success': isRegisterSuccess }" :env="env"
  >
    <div class="v-login-index__role" v-if="isRoleSelect && !isRegisterSuccess">
      <role-select :options="useOptions" @clickCallback="roleCallback" />
    </div>
    <div class="v-login-index__success" v-else-if="isRegisterSuccess && !isApiCheckRole">
      <div class="v-login-index__close"
        @click="successCallback">×</div>
      <success-box :options="useOptions" :roleId="roleId" @clickCallback="successCallback" />
    </div>
    <div class="v-login-index__box" v-else-if="!isApiCheckRole" :isRegisterTab="isRegisterTab">
      <div class="v-login-index__close" v-if="useOptions.closeCallback"
        @click="useOptions.closeCallback">×</div>
      <div class="v-login-index__poster">
        <poster :img="posterImg" />
      </div>
      <div class="v-login-index__login" v-if="!isRegister">
        <login-box :options="useOptions" @changeRegister="changeType(true)" />
      </div>
      <div class="v-login-index__register" v-else>
        <register-box :options="useOptions"
          @changeLogin="changeType()"
          @registerCallback="registerCallback"
        />
      </div>
    </div>
  </div>
</template>

<script>
import defaults from './src/libs/defaults';
import logger from './src/libs/logger';
import RegisterBox from './src/RegisterBox.vue';
import RoleSelect from './src/RoleSelect.vue';
import LoginBox from './src/LoginBox.vue';
import Poster from './src/components/Poster.vue';
import SuccessBox from './src/components/SuccessBox.vue';
import { apiPoster, apiShowRoles } from './src/libs/service';
import { ENV_API_HOST, OSS_HOST } from './src/libs/constants';

export default {
  name: 'v-login',
  props: {
    options: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      isRoleSelect: false,
      isRegisterSuccess: false,
      isRegister: false,
      posterImg: '',
      regResult: null,
      roleId: '',
    };
  },
  components: {
    Poster,
    LoginBox,
    RoleSelect,
    RegisterBox,
    SuccessBox,
  },
  computed: {
    useOptions() {
      const options = Object.assign({}, defaults, this.options);
      console.log('useOptions', options); // eslint-disable-line
      return options;
    },
    env() {
      this.getPoster();
      return this.useOptions.env;
    },
    isRegisterTab() {
      this.changeType('', true);
      return this.useOptions.isRegisterTab;
    },
    isApiCheckRole() {
      if (this.useOptions.isRegisterRole && this.useOptions.isApiCheckRole) {
        this.getShowRoles(); // 是否实时检查角色接口
      }
      return this.useOptions.isApiCheckRole;
    },
  },
  created() {
    logger.init({
      env: this.env,
    });
  },
  methods: {
    getPoster() {
      let id = 'denglu_001';
      if (this.isRegister) {
        id = 'zhuce_001';
      }
      apiPoster(ENV_API_HOST[this.useOptions.env].www, id, (img) => {
        this.posterImg = `${ENV_API_HOST[this.useOptions.env].adLink}${img}`;
      }, () => {
        this.posterImg = this.posterImg || `${OSS_HOST}/common/images/passport.png`;
      });
    },
    getShowRoles(result) {
      apiShowRoles(ENV_API_HOST[this.useOptions.env].www, (isShow) => {
        if (isShow) { // 显示角色弹窗
          this.isRoleSelect = true;
          this.isRegisterSuccess = false;
          this.useOptions.showRolesCallback(true);
        } else {
          this.isRoleSelect = false;
          if (result && this.useOptions.registerSuccessCallback) {
            this.isRegisterSuccess = true;
          }
          this.useOptions.showRolesCallback(false);
        }
      }, () => {
        this.isRoleSelect = false;
        if (result && this.useOptions.registerSuccessCallback) {
          this.isRegisterSuccess = true;
        }
        this.useOptions.showRolesCallback(false);
      });
    },
    changeType(isRegister, isChangeOptions) {
      if (isChangeOptions) {
        this.isRegister = this.useOptions.isRegisterTab;
      } else {
        this.isRegister = isRegister;
      }
    },
    registerCallback(result) {
      this.regResult = result || null;
      if (this.useOptions.registerCallback && typeof this.useOptions.registerCallback === 'function') {
        this.useOptions.registerCallback(result);
      }
      this.getShowRoles(result);
    },
    roleCallback(result, roleId) {
      if (this.useOptions.selectRoleCallback && typeof this.useOptions.selectRoleCallback === 'function') {
        this.useOptions.selectRoleCallback(result, this.regResult);
      }
      if (result && this.useOptions.registerSuccessCallback) {
        this.isRegisterSuccess = true;
      }
      this.roleId = roleId;
    },
    successCallback() {
      this.useOptions.closeCallback();
      if (this.useOptions.registerSuccessCallback && typeof this.useOptions.registerSuccessCallback === 'function') {
        this.useOptions.registerSuccessCallback(this.regResult);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-login-index {
  position: relative;
  width: 1060px;
  height: 600px;
  margin: 0 auto;
  box-shadow: 0px 6px 30px 0px rgba(0,0,0,0.3);
  border-radius: 8px;
  * {
    box-sizing: unset;
    -webkit-box-sizing: unset;
  }
  &.role {
    height: 488px;
  }
  &.success {
    width: 900px;
    height: 600px;
  }
}
.v-login-index__box,
.v-login-index__role,
.v-login-index__success {
  position: relative;
  width: 100%;
  height: 100%;
}
.v-login-index__role,
.v-login-index__success {
  background-color: #fff;
  border-radius: 8px;
}
.v-login-index__login,
.v-login-index__register {
  position: relative;
  z-index: 2;
  float: right;
  width: 420px;
  height: 100%;
  background:rgba(255,255,255,1);
  box-shadow:0px 6px 20px 0px rgba(0,0,0,0.2);
  border-radius: 8px;
}
.v-login-index__poster {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 660px;
  height: 100%;
  border-radius: 8px 0 0 8px;
  overflow: hidden;
}
.v-login-index__close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 32px;
  height: 32px;
  color: #999;
  font-size: 28px;
  text-align: center;
  line-height: 32px;
  z-index: 3;
  cursor: pointer;
}
</style>
